// extracted by mini-css-extract-plugin
export var content = "_mm-1";
export var divider = "_mm-0";